
import { smoothScrollToTargetId } from '~/helpers/util'

export default {
  name: 'MoleculeAnchor',
  props: {
    title: {
      required: false,
      type: String,
      default: ''
    },
    subtitle: {
      required: false,
      type: String,
      default: ''
    },
    image: {
      required: false,
      type: String,
      default: ''
    },
    imagePosition: {
      required: false,
      type: String,
      default: "center center",
    },
    anchor: {
      required: false,
      type: String,
      default: 'javascript:void(0)'
    }
  },
  methods: {
    goToAnchor(anchor) {
      smoothScrollToTargetId(anchor)
    },
    resourceUrl(url) {
      if (url.includes('://')) {
        return url
      }
      return `${this.$store.getters['base/cdnBase']}/${url}`
    }
  }
}
